module.exports = __webpack_public_path__ + "assets/templates/loop-d839ad9325f776d1a5cfeec6b0c8b6ca.mud";